import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/** Lo que fue impuesto en las compras, leído de Siigo. Contadora y administrador. Adjudicación 322. */
export const rutaImpuestosCompras = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/impuestos-compras',
  component: lazyRouteComponent(() => import('./impuestos-compras-pantalla.js'), 'RutaImpuestosCompras'),
});
